/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SourcesRouteImport } from './routes/sources'
import { Route as ReviewRouteImport } from './routes/review'
import { Route as LeadsRouteImport } from './routes/leads'
import { Route as IndexRouteImport } from './routes/index'

const SourcesRoute = SourcesRouteImport.update({
  id: '/sources',
  path: '/sources',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewRoute = ReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => rootRouteImport,
} as any)
const LeadsRoute = LeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/leads': typeof LeadsRoute
  '/review': typeof ReviewRoute
  '/sources': typeof SourcesRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/leads': typeof LeadsRoute
  '/review': typeof ReviewRoute
  '/sources': typeof SourcesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/leads': typeof LeadsRoute
  '/review': typeof ReviewRoute
  '/sources': typeof SourcesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/leads' | '/review' | '/sources'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/leads' | '/review' | '/sources'
  id: '__root__' | '/' | '/leads' | '/review' | '/sources'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LeadsRoute: typeof LeadsRoute
  ReviewRoute: typeof ReviewRoute
  SourcesRoute: typeof SourcesRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sources': {
      id: '/sources'
      path: '/sources'
      fullPath: '/sources'
      preLoaderRoute: typeof SourcesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/review': {
      id: '/review'
      path: '/review'
      fullPath: '/review'
      preLoaderRoute: typeof ReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/leads': {
      id: '/leads'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof LeadsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LeadsRoute: LeadsRoute,
  ReviewRoute: ReviewRoute,
  SourcesRoute: SourcesRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
